const SUBSCRIPTION_STATUS_LABELS = {
  draft: 'Draft',
  // We do not want to confuse merchants with the concept of an expired draft, so we just name them drafts.
  draft_expired: 'Draft',
  incomplete: 'Incomplete',
  trialing: 'Trialing',
  scheduled: 'Scheduled',
  active: 'Active',
  completed: 'Completed',
  past_due: 'Overdue',
  canceled: 'Canceled',
  incomplete_expired: 'Failed',
  unpaid: 'Failed',
  failed: 'Failed',
};

export default function getSubscriptionStatusLabel(status) {
  return SUBSCRIPTION_STATUS_LABELS[status] || 'Unknown';
}
